export default function(container: HTMLDivElement): void {
    const selectField = document.getElementById('date-range') as HTMLSelectElement|null;

    if (selectField === null) {
        return;
    }

    selectField.addEventListener('change', () => {
        showHide(selectField.options[selectField.selectedIndex].value);
    }, false);

    const showHide = (selectValue: string) => {
        container.style.display = (selectValue === 'custom') ? 'block' : 'none';
    };

    // default value
    showHide(selectField.options[selectField.selectedIndex].value);
}
